//src/services/adminHomepage.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminCategoryCards = () =>
  adminApiRequest("/homepage/admin/category-cards");

export const updateAdminCategoryCard = (id, data) =>
  adminApiRequest(`/homepage/admin/category-cards/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const getAdminLuxuryVideos = () =>
  adminApiRequest("/homepage/admin/luxury-videos");

export const updateAdminLuxuryVideo = (id, data) =>
  adminApiRequest(`/homepage/admin/luxury-videos/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const getAdminCategoryHero = () =>
  adminApiRequest("/homepage/admin/category-hero");

export const updateAdminCategoryHero = (data) =>
  adminApiRequest("/homepage/admin/category-hero", {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const getAdminFeaturedCategories = () =>
  adminApiRequest("/homepage/admin/featured-categories");

export const updateAdminFeaturedCategory = (id, data) =>
  adminApiRequest(`/homepage/admin/featured-categories/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const getAdminCategoryCarousel = () =>
  adminApiRequest("/homepage/admin/category-carousel");

export const updateAdminCategoryCarouselImage = (id, data) =>
  adminApiRequest(`/homepage/admin/category-carousel/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const updateAdminCategoryCarouselOrder = (id, sort_order) =>
  adminApiRequest(`/homepage/admin/category-carousel/${id}/order`, {
    method: "PUT",
    body: JSON.stringify({ sort_order }),
  });

export const getAdminPopularSearchOrder = () =>
  adminApiRequest("/homepage/admin/popular-search-order");

export const updateAdminPopularSearchOrder = (order) =>
  adminApiRequest("/homepage/admin/popular-search-order", {
    method: "PUT",
    body: JSON.stringify({ order }),
  });

export const getAdminAccessoriesSection = () =>
  adminApiRequest("/homepage/admin/accessories-section");

export const updateAdminAccessoriesSection = (data) =>
  adminApiRequest("/homepage/admin/accessories-section", {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const getAdminFlatsMiniSection = () =>
  adminApiRequest("/homepage/admin/flats-mini-section");

export const updateAdminFlatsMiniSection = (data) =>
  adminApiRequest("/homepage/admin/flats-mini-section", {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const createAdminLuxuryVideo = (data) =>
  adminApiRequest("/homepage/admin/luxury-videos", {
    method: "POST",
    body: JSON.stringify(data),
  });

  export const deleteAdminLuxuryVideo = (id) =>
  adminApiRequest(`/homepage/admin/luxury-videos/${id}`, {
    method: "DELETE",
  });


export const uploadAdminLuxuryVideo = async (file) => {
  const formData = new FormData();
  formData.append("video", file);

  const BASE =
  process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace(/\/api$/, "")
    : "http://localhost:5000";


  // ✅ MUST MATCH adminApiRequest
  const token = localStorage.getItem("adminToken");

  const res = await fetch(
    `${BASE}/api/homepage/admin/luxury-videos/upload`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    }
  );

  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || "Video upload failed");
  }

  return res.json();
};


export const uploadAdminImage = async (file) => {
  const form = new FormData();
  form.append("image", file);

  const BASE =
    process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL.replace(/\/api$/, "")
      : "http://localhost:5000";

  const token = localStorage.getItem("adminToken");

  const res = await fetch(`${BASE}/api/homepage/admin/upload-image`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: form,
  });

  if (!res.ok) {
    throw new Error("Image upload failed");
  }

  return res.json(); // { url: "/images/xxx.jpg" }
};


